/* globals Drupal */

import PropTypes from 'prop-types';
import React from 'reactn';

const BookingSummary = ({ booking: { fullName, packageType, adults, children } }) => {
    const adultsString = Drupal.formatPlural(adults, '@count adult', '@count adults');
    const childrenString = Drupal.formatPlural(children, '@count child', '@count children');

    return (
        <div className="booking-summary">
            <h3 className="booking-summary__name">{fullName}</h3>
            <p className="heading-4 booking-summary__info">{packageType}</p>
            <p className="heading-4 booking-summary__info">{`${adultsString} - ${childrenString}`}</p>
        </div>
    );
};

BookingSummary.propTypes = {
    booking: PropTypes.shape({
        fullName: PropTypes.string.isRequired,
        packageType: PropTypes.string.isRequired,
        adults: PropTypes.number.isRequired,
        children: PropTypes.number.isRequired,
    }).isRequired,
};

const ErrorSummary = ({ error }) => (
    <div className="booking-summary">
        <h3 className="booking-summary__error">{error}</h3>
    </div>
);

ErrorSummary.propTypes = {
    error: PropTypes.string.isRequired,
};

export { BookingSummary, ErrorSummary }
